import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'zwi-email',
    templateUrl: './email.component.html',
    styleUrls: ['./email.component.scss'],
    standalone: false
})
export class EmailComponent {}
